// 管理端使用登录态列表和详情接口，附件访问由后端统一校验。
export default {
  list: '/ygsjzs/paSpecialWork/selectPaSpecialWorkTicketByPage',
  detail: '/ygsjzs/paSpecialWork/selectInternalPaSpecialWorkTicketById',
  add: '/ygsjzs/paSpecialWork/insertPaSpecialWorkTicket',
  process: '/ygsjzs/paSpecialWork/processPaSpecialWorkTicket',
  remove: '/ygsjzs/paSpecialWork/deletePaSpecialWorkTicket'
}
